import { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'AppController',
	loadComponent: () => import('./AppController' /* webpackChunkName: "AppController" */),
}

export default entry
